import { Box } from '@chakra-ui/react';
import { CustomHeading } from 'shared-components';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { ApplicationState } from '../../../../../store';
import { FileList } from '../../../../FileList/FileList';
import { PrevNextButtons } from './../../../../PrevNextButtons';
import { SectionHeader, SectionTitles } from '@/components/molecules/SectionHeader';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';
import { HighestStudy } from './components/HighestStudy';
import { PreviousStudies } from './components/PreviousStudies';

export default function Education() {
  const navigate = useNavigate();
  const { application, allDocuments } = useSelector((state: ApplicationState) => state.apply);
  const { studyHistory: studyHistoryCurrent, initiallySubmittedApplication } = application;
  const { studyHistory: studyHistoryInitial } = initiallySubmittedApplication || {};

  const { nextRoute, previousRoute } = useTaskNavigation();

  const files = allDocuments?.academicTranscript || [];

  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <SectionHeader title={SectionTitles.EDUCATION} />

        <FileList files={files} />

        <CustomHeading level="h2" mb={2} mt={6} fontSize="md">
          Data
        </CustomHeading>

        <Box mb={6}>
          <HighestStudy studyHistoryCurrent={studyHistoryCurrent} studyHistoryInitial={studyHistoryInitial} />

          <PreviousStudies studyHistoryCurrent={studyHistoryCurrent} studyHistoryInitial={studyHistoryInitial} />
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={previousRoute ? () => navigate(previousRoute) : undefined}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
